<child-header title="Confirm Pending Total" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content>
  <p>
    Your new Total is &nbsp;<span
      class="color-red bold">{{data.totalPriceChange | currency:'AUD':'symbol-narrow':'.2-2'}}</span>&nbsp;&nbsp;
    Variance Amount: &nbsp;<span
      class="color-red bold">{{data.pendingTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
  </p>
  <p *ngIf="data.hasNCEAddon">Make sure you have eligible offer before buying an ADD-ON offer</p>
  <p>
    Once you have confirmed the order total noted above this request will be sent to Microsoft for verification and
    actioning. This portal will be automatically updated once Microsoft have confirmed your requested changes are
    live in their systems. Until this confirmation is received, your Microsoft CSP subscriptions will remain in
    their
    current state.
    If you have any questions regarding this process or the changes you are applying, please contact your Dicker
    Data
    representative.
  </p>

  <p *ngIf="data.hasNCE">Changes to <span class="nce">New Commerce Experience</span> will not be effective until next renewal</p>
  <p *ngIf="data?.hasTrial" style="color: red;">Trial offers will be auto-renewed automatically to a paid subscription after 30 days, please turn off auto-renew if you do not want to auto-renew automatically</p>

  <mat-form-field>
    <input matInput numberLettersOnly type="text" maxlength="30" class="poReference" [(ngModel)]="poReference" placeholder="PO REFERENCE" (input)="commonService.subscription_customer_ref_validation($event)" />
  </mat-form-field>
  <mat-checkbox [(ngModel)]="confirmChecked">
    Partner attestation *
  </mat-checkbox>
  <div class="confirm-label" (click)="checkConfirmBox()">
    <label>
      I confirm that my organization is acting as an Indirect Partner when choosing a Reseller and as a Direct Partner in the absence of selecting a reseller.<br/>
      I confirm that I am not reselling products purchased within this order to other partners that are affiliated with my parent organization
    </label>
  </div>
  
</div>
<div mat-dialog-actions>
  <button mat-button class="button button-red button-large continue" [disabled]="!confirmChecked" (click)="continueSaveSubscription()">Continue</button>
</div>

